import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react';
import {
  TextField,
  Typography,
  Box,
  Button,
  DialogActions,
  FormControlLabel,
  Switch,
} from '@mui/material';

import { convertFormData } from '../../utils/form';
import { ImageLibrarySelect } from '../../pages/dashboard/media/MediaPage';
import { NewsPost } from '../../generated/graphql';
import { FullWidthForm } from '../common/CommonDivs';
import { useRouteLoaderData } from 'react-router-dom';
import { CampQuery } from '../../generated/graphql';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


interface CreateNewsPostProps {
  permissions: any;
  onSubmit: (data) => void;
  onCancel: () => void;
  existingItem?: NewsPost;
}
export const CreateNewsPost = observer(function CreateNewsPost(
  props: CreateNewsPostProps,
) {
  let { onSubmit, onCancel, existingItem, permissions } = props;

  const [value, setValue] = useState();

  const camp = useRouteLoaderData('camp') as CampQuery['camp'];

  const isEdit = !!existingItem;

  const [restrictedAudience, setRestrictedAudience] = useState(false);
  const [selectedImage, setSelectedImage] = useState(-1);
  const [state, setState] = useState({});

  let modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      [{ 'align': [] }],
      ['bold', 'italic', 'underline','strike'],
      [{'list': 'ordered'}, {'list': 'bullet'}],
      ['link', 'image']
    ],
  };

  let formats = [
    'header','align',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link', 'image'
  ];

  useEffect(() => {
    if (!existingItem) return;
    setRestrictedAudience(existingItem.restrictedAudience);
    if (existingItem.image) {
      setSelectedImage(existingItem.image.id);
    }

    setValue(JSON.parse(existingItem.description));

  }, [existingItem]);

  useEffect(() => {

    let itemPermissions = [];

    if (existingItem && existingItem.permissions)
    {
      itemPermissions = JSON.parse(existingItem.permissions);
    }

    permissions.map(item => {
      setState((s) => ({
        ...s,
        [item.id]: itemPermissions[item.id],
      }));
    })

  }, [permissions, existingItem]);

  useEffect(() => {
    console.log('value', value);
  }, [value])

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const data = convertFormData(e.target);
    data.restrictedAudience = restrictedAudience;
    data.imageId = selectedImage;
    data.description = JSON.stringify(value);
    data.permissions = JSON.stringify(state);


    onSubmit(data);
  };

  return (
    <Box p={4} paddingBottom={1}>
      <Typography component="h2" variant="h5">
        {isEdit ? 'Uppdatera inlägg' : 'Skapa nytt inlägg'}
      </Typography>
      <FullWidthForm noValidate onSubmit={submit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="title"
          name="title"
          label="Rubrik"
          autoFocus
          defaultValue={existingItem ? existingItem.title : ''}
        />
        
        <ReactQuill theme="snow" value={value} onChange={(val, delta, source, editor) => {

          let content = editor.getContents();

          delta.ops.map(async (op) => {

            if(op?.insert?.image)
            {
              let orgimg = op.insert.image;

              const img = new Image();

              img.src = orgimg;

             if (img.width > 600)
            {
              
              await resizeImage(orgimg).then((resized) => {

                content.ops.map((op) => {
                  if(op?.insert?.image === orgimg)
                  {
                    op.insert.image = resized;
                  }
                });
                // @ts-ignore
                setValue(content);

              });
            }
          }
        });

          // @ts-ignore
          setValue(content);
        }}
        modules={modules} formats={formats} style={{height: 200, marginBottom: 75}}/>

       

{
              permissions.map((item) => {
                return (
                  <FormControlLabel
                  key={item.id}
                  control={
                    <Switch
                      // @ts-ignore
                      checked={!!state[item.id]}
                      onChange={(event) => {
                        setState((s) => ({
                          ...s,
                          [item.id]: event.target.checked,
                        }));
                      }}
                    />
                  }
                  label={item.name}
                />
                )
              })
            }

        <DialogActions>
          <Button
            color="secondary"
            type="button"
            onClick={onCancel}
            id="cancel"
          >
            {'Avbryt'}
          </Button>
          <Button color="primary" type="submit" id="submit">
            {isEdit ? 'Spara inlägg' : 'Skapa nytt inlägg'}
          </Button>
        </DialogActions>
      </FullWidthForm>
    </Box>
  );
});

const resizeImage = (base64Str, maxWidth = 600 , maxHeight = 800) => {
  return new Promise((resolve) => {
    let img = new Image()
    img.src = base64Str
    img.onload = () => {
      let canvas = document.createElement('canvas')
      const MAX_WIDTH = maxWidth
      const MAX_HEIGHT = maxHeight
      let width = img.width
      let height = img.height

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      canvas.width = width
      canvas.height = height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL('image/jpeg', 0.5))
    }
  })
}